var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarRentalsStep1 = function SvgCarRentalsStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 166,
    viewBox: "0 0 191 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4186 161.757C160.578 161.757 167.243 143.908 167.243 80.8787C167.243 17.8491 160.578 0 91.4186 0C22.2597 0 15.5938 17.8491 15.5938 80.8787C15.5938 143.908 22.2597 161.757 91.4186 161.757Z",
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8168_48835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.844 36.1816C158.021 36.1816 159.685 37.8458 159.685 40.022V124.127C159.685 126.303 158.021 127.967 155.844 127.967H26.8053C24.629 127.967 22.9648 126.303 22.9648 124.127V40.022C22.9648 37.8458 24.629 36.1816 26.8053 36.1816H155.844Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.685 40.022V47.8308H22.9648V40.022C22.9648 37.8458 24.629 36.1816 26.8053 36.1816H155.844C158.021 36.1816 159.685 37.8458 159.685 40.022Z",
    fill: "url(#paint0_linear_8168_48835)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M29.1095 43.6057C30.0286 43.6057 30.7737 42.8606 30.7737 41.9415C30.7737 41.0224 30.0286 40.2773 29.1095 40.2773C28.1904 40.2773 27.4453 41.0224 27.4453 41.9415C27.4453 42.8606 28.1904 43.6057 29.1095 43.6057Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.8478 43.6057C34.7669 43.6057 35.512 42.8606 35.512 41.9415C35.512 41.0224 34.7669 40.2773 33.8478 40.2773C32.9287 40.2773 32.1836 41.0224 32.1836 41.9415C32.1836 42.8606 32.9287 43.6057 33.8478 43.6057Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.5841 43.6057C39.5032 43.6057 40.2483 42.8606 40.2483 41.9415C40.2483 41.0224 39.5032 40.2773 38.5841 40.2773C37.665 40.2773 36.9199 41.0224 36.9199 41.9415C36.9199 42.8606 37.665 43.6057 38.5841 43.6057Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.779 83.1621H105.023C104.254 83.1621 103.486 82.5221 103.486 81.626V66.6485C103.486 65.8804 104.126 65.1123 105.023 65.1123H147.779C148.548 65.1123 149.316 65.7524 149.316 66.6485V81.754C149.188 82.5221 148.548 83.1621 147.779 83.1621Z",
    fill: "#F4F4F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.188 108.254C149.188 109.022 148.548 109.79 147.651 109.79H105.023C104.254 109.79 103.486 109.15 103.486 108.254V93.1485C103.486 92.3804 104.126 91.6123 105.023 91.6123H147.779C148.548 91.6123 149.316 92.2524 149.316 93.1485V108.254H149.188Z",
    fill: "#E6ECF5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8168_48835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.214 132.193H124.737C123.585 132.193 122.561 131.296 122.561 130.016V116.191C122.561 115.039 123.457 114.015 124.737 114.015H166.214C167.366 114.015 168.39 114.911 168.39 116.191V130.016C168.262 131.296 167.366 132.193 166.214 132.193Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.454 121.184H131.01C130.498 121.184 130.242 120.8 130.242 120.416C130.242 119.903 130.626 119.647 131.01 119.647H160.326C160.838 119.647 161.094 120.031 161.094 120.416C161.222 120.8 160.838 121.184 160.454 121.184Z",
    fill: "url(#paint1_linear_8168_48835)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.213 127.199H131.01C130.498 127.199 130.242 126.815 130.242 126.431C130.242 125.919 130.626 125.663 131.01 125.663H150.213C150.725 125.663 150.981 126.047 150.981 126.431C150.981 126.815 150.597 127.199 150.213 127.199Z",
    fill: "url(#paint2_linear_8168_48835)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M140.611 71.8985H111.936C111.552 71.8985 111.168 71.5144 111.168 71.1304C111.168 70.7463 111.552 70.3623 111.936 70.3623H140.611C140.995 70.3623 141.379 70.7463 141.379 71.1304C141.379 71.5144 140.995 71.8985 140.611 71.8985Z",
    fill: "url(#paint3_linear_8168_48835)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.626 77.7881H111.936C111.552 77.7881 111.168 77.4041 111.168 77.02C111.168 76.636 111.552 76.252 111.936 76.252H130.626C131.01 76.252 131.394 76.636 131.394 77.02C131.394 77.4041 131.01 77.7881 130.626 77.7881Z",
    fill: "url(#paint4_linear_8168_48835)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.611 98.3975H111.936C111.552 98.3975 111.168 98.0135 111.168 97.6294C111.168 97.2454 111.552 96.8613 111.936 96.8613H140.611C140.995 96.8613 141.379 97.2454 141.379 97.6294C141.379 98.1415 140.995 98.3975 140.611 98.3975Z",
    fill: "url(#paint5_linear_8168_48835)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.626 104.413H111.936C111.552 104.413 111.168 104.029 111.168 103.645C111.168 103.261 111.552 102.877 111.936 102.877H130.626C131.01 102.877 131.394 103.261 131.394 103.645C131.394 104.029 131.01 104.413 130.626 104.413Z",
    fill: "url(#paint6_linear_8168_48835)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9997 84.3147C53.1914 84.3147 54.9682 82.538 54.9682 80.3463C54.9682 78.1546 53.1914 76.3779 50.9997 76.3779C48.808 76.3779 47.0312 78.1546 47.0312 80.3463C47.0312 82.538 48.808 84.3147 50.9997 84.3147Z",
    fill: "#CED7E2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1267 95.9909L47.8994 94.5911C47.8994 94.5911 51.1315 80.192 42.9371 81.6836C34.7453 83.1725 33.9772 91.4297 36.1267 95.9909Z",
    fill: "url(#paint7_linear_8168_48835)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4058 102.083L109.38 100.698C109.38 100.698 112.612 86.2994 104.418 87.791C96.2236 89.2825 95.3533 92.8869 97.4058 102.085V102.083Z",
    fill: "url(#paint8_linear_8168_48835)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.046 93.825C133.046 93.825 138.422 91.0228 141.901 90.8969C145.382 90.7737 148.035 92.8236 148.035 92.8236C148.035 92.8236 150.538 94.5642 149.98 97.2354C149.422 99.9065 140.1 101.275 134.941 100.467C129.782 99.6601 130.217 98.0427 130.404 96.7399C130.59 95.4345 133.046 93.825 133.046 93.825Z",
    fill: "url(#paint9_linear_8168_48835)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.729 97.9817C112.488 92.9382 108.454 89.1818 104.163 89.672C102.755 89.8319 106.42 89.2578 107.141 89.2578C116.26 89.2526 118.012 104.577 108.866 106.103L106.635 106.475C110.121 105.893 112.942 102.462 112.727 97.9817H112.729Z",
    fill: "url(#paint10_linear_8168_48835)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105.359 89.6426C101.209 89.37 97.7906 92.935 97.7199 97.6036C97.6491 102.272 100.955 106.278 105.104 106.55C109.254 106.823 112.672 103.258 112.743 98.5892C112.814 93.9206 109.508 89.9152 105.359 89.6426Z",
    fill: "url(#paint11_linear_8168_48835)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.316 92.3362C102.488 92.1501 100.157 94.5801 100.11 97.7624C100.063 100.945 102.315 103.676 105.143 103.86C107.972 104.046 110.302 101.616 110.349 98.4334C110.396 95.2511 108.145 92.5223 105.316 92.3362Z",
    fill: "url(#paint12_linear_8168_48835)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8867 86.4947C42.0663 86.3295 42.7558 86.1172 43.6025 86.1172C43.7231 86.1172 43.8463 86.1198 43.9695 86.1277C47.3537 86.3505 50.0747 89.6246 50.017 93.4543C49.9672 96.7966 47.8229 99.4467 45.0154 99.9133L43.1883 100.217C45.9958 99.7482 48.1375 97.098 48.1899 93.7584C48.2554 89.4201 44.7611 85.8472 40.8867 86.492V86.4947Z",
    fill: "url(#paint13_linear_8168_48835)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1429 86.4348C38.7456 86.212 35.9433 89.1322 35.8857 92.9567C35.828 96.7813 38.5359 100.061 41.9332 100.283C45.3305 100.506 48.1328 97.586 48.1905 93.7615C48.2481 89.9369 45.5402 86.6576 42.1429 86.4348Z",
    fill: "url(#paint14_linear_8168_48835)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1051 88.7911C39.8638 88.6443 38.0184 90.5683 37.9791 93.0901C37.9424 95.6118 39.7275 97.7744 41.9662 97.9212C44.2075 98.068 46.0529 96.144 46.0923 93.6222C46.1316 91.1005 44.3438 88.9379 42.1051 88.7911Z",
    fill: "url(#paint15_linear_8168_48835)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.158 78.9187C117.158 78.9187 99.5819 68.5303 91.6758 68.5303L113.439 78.7168L117.158 78.9187Z",
    fill: "url(#paint16_linear_8168_48835)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.839 78.6735L92.8985 79.4625C85.8338 73.0691 82.8638 70.1908 77.8281 69.1449L92.2248 68.542C101.83 70.0807 113.689 78.0601 114.839 78.6735Z",
    fill: "url(#paint17_linear_8168_48835)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2078 92.822C33.8291 94.7487 36.128 95.9886 36.128 95.9886C35.8292 95.0292 35.5592 93.5534 35.6431 92.0199C35.803 89.1024 37.2343 85.9725 42.1546 85.8126C46.2492 85.6763 47.8142 88.9634 48.6635 91.8023C48.8654 92.4787 48.9361 93.1602 48.9257 93.8155C48.9204 94.1065 48.9021 94.3922 48.8706 94.6675C48.674 96.3949 48.0213 97.724 48.0213 97.724L97.3925 102.081H97.4029C97.1775 100.466 97.1093 98.9665 97.1906 97.6348C97.264 96.3976 97.4659 95.3071 97.7883 94.4053C99.5787 89.4143 104.627 87.5348 109.349 89.9622C113.04 91.8626 114.038 95.8261 114.196 98.977C114.321 101.504 113.907 103.509 113.907 103.509C142.32 106.377 150.397 100.542 150.397 100.542V94.1878C149.71 86.675 139.872 83.2777 138.821 82.9343C147.107 85.7313 147.962 92.7408 148.035 92.8194C149.178 94.2795 149.718 96.2875 149.718 96.2875C149.212 97.1761 148.061 98.3714 145.888 98.9586C140.792 100.337 134.482 100.154 130.807 97.4278C131.041 96.3556 131.602 95.4539 132.102 94.8195C132.603 94.1851 133.046 93.8208 133.046 93.8208C131.809 92.8168 129.57 89.5191 126.93 87.9621C125.617 87.2281 124.123 86.4496 122.403 85.8152C118.361 84.321 114.064 83.5897 110.038 83.0392C106.014 82.4913 102.229 82.2213 99.1042 81.9382C97.534 81.6971 96.0713 81.4035 95.4159 81.0758C93.6727 80.2081 85.7823 72.1003 81.2447 70.1107C76.7097 68.1237 69.0212 68.3623 61.9513 68.9311C51.7934 69.7489 44.5191 74.4883 42.2201 75.917C39.9212 77.3456 36.8804 78.7166 35.3207 80.3287C33.8737 81.8281 33.1633 85.671 32.9929 88.7747C32.8959 90.5703 32.9798 92.1195 33.2078 92.8247V92.822Z",
    fill: "url(#paint18_linear_8168_48835)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M113.936 85.9389C114.387 85.4802 121.302 87.3571 123.818 88.5288C126.335 89.7006 130.306 91.9916 130.306 91.9916C130.306 91.9916 125.632 92.238 121.205 91.4778C117.134 90.7806 112.979 86.9115 113.933 85.9363L113.936 85.9389Z",
    fill: "url(#paint19_linear_8168_48835)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M113.936 85.9392C114.258 85.3834 121.302 86.8435 123.818 88.0153C126.335 89.187 129.876 91.6721 129.876 91.6721C129.876 91.6721 125.54 91.4676 121.113 90.71C117.042 90.0127 113.563 86.5814 113.936 85.9392Z",
    fill: "url(#paint20_linear_8168_48835)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3542 79.4655C94.2874 80.2833 95.0109 80.8758 95.4146 81.0776C96.0699 81.4053 97.5327 81.7015 99.1029 81.94C105.095 82.4826 110.674 82.868 116.64 84.2075C118.577 84.6426 120.52 85.1695 122.42 85.8249C126.853 87.3505 131.1 92.2419 133.042 93.8226C133.642 93.6968 134.227 93.5736 134.798 93.453C139.488 92.4778 143.344 91.8173 148.031 92.8212C148.031 92.8212 146.925 85.6702 138.725 82.9073C130.525 80.1444 114.836 78.6738 114.836 78.6738L93.3516 79.4629L93.3542 79.4655Z",
    fill: "url(#paint21_linear_8168_48835)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2871 80.6405C80.934 80.9655 55.7189 78.8239 53.247 78.6351C50.7776 78.449 45.6738 77.8435 45.9779 75.6992L89.2333 79.259L90.2845 80.6378L90.2871 80.6405Z",
    fill: "url(#paint22_linear_8168_48835)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4167 79.4613C89.4167 79.4613 81.5526 70.5749 74.3149 69.8226C66.1886 68.9785 52.3084 69.8016 46.3028 75.1858C44.9502 76.3969 48.0277 77.6106 51.8497 77.7967C57.8893 78.0903 89.4167 79.4613 89.4167 79.4613Z",
    fill: "url(#paint23_linear_8168_48835)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2361 79.262H86.211C86.211 79.262 86.8165 77.1649 85.4665 76.5122C84.1139 75.8595 78.0375 75.6209 77.356 77.351C76.9759 78.3183 78.0978 79.1152 80.423 79.6788C82.6512 80.2188 86.0065 80.5517 90.2899 80.6408L89.2387 79.262H89.2361Z",
    fill: "url(#paint24_linear_8168_48835)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3086 68.6075C72.2316 68.618 75.1151 68.673 77.8911 69.255L92.2249 68.5446C91.5014 68.4266 90.7936 68.348 90.1015 68.3113C87.2128 68.1566 82.9242 68.1094 78.4809 68.2352C74.8687 68.3375 71.2721 68.6075 67.3086 68.6075Z",
    fill: "url(#paint25_linear_8168_48835)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M113.906 103.514C142.319 106.382 150.396 100.547 150.396 100.547V98.4707C149.219 99.2676 147.56 100.091 145.255 100.701C138.977 102.363 129.873 100.224 129.873 100.224L114.195 98.9845C114.32 101.511 113.906 103.517 113.906 103.517V103.514Z",
    fill: "url(#paint26_linear_8168_48835)"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3989 99.1622C63.3989 99.1622 62.5915 86.425 63.1499 79.4654C63.7082 72.5057 65.7896 68.71 65.7896 68.71H66.521C66.521 68.71 64.8433 72.5057 64.2849 79.4654C63.7266 86.425 64.2849 99.1622 64.2849 99.1622H63.4015H63.3989Z",
    fill: "url(#paint27_linear_8168_48835)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M97.4064 102.085C97.1836 100.47 97.1128 98.968 97.1941 97.6389L48.9317 93.8223C48.9029 95.9429 48.0273 97.7307 48.0273 97.7307L97.409 102.087L97.4064 102.085Z",
    fill: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M48.0241 97.7248L97.3953 102.081C97.1096 102.034 91.0017 101.049 89.4184 99.8192C87.7984 98.561 86.2623 97.5596 84.0944 97.4495C82.1467 97.3499 54.4413 95.1191 48.8708 94.6709C48.6742 96.3984 48.0215 97.7274 48.0215 97.7274L48.0241 97.7248Z",
    fill: "url(#paint28_linear_8168_48835)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.2078 92.8224C33.8291 94.7491 36.128 95.989 36.128 95.989C35.8292 95.0296 35.5592 93.5538 35.6431 92.0203C35.6431 92.0203 33.276 91.1422 32.9929 88.7803C32.9929 88.7777 32.9929 88.7751 32.9929 88.7725C32.8959 90.5681 32.9798 92.1173 33.2078 92.8224Z",
    fill: "url(#paint29_linear_8168_48835)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M111.889 83.3125C113.457 83.5589 115.051 83.8525 116.645 84.209C118.582 84.6441 120.524 85.171 122.425 85.8264C126.857 87.352 131.104 92.2434 133.047 93.8241C133.647 93.6983 134.231 93.5751 134.803 93.4545C129.264 86.1488 119.774 84.4947 111.887 83.3125H111.889Z",
    fill: "url(#paint30_linear_8168_48835)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.254 136.694C133.182 136.694 144.473 125.403 144.473 111.475C144.473 97.5476 133.182 86.2568 119.254 86.2568C105.326 86.2568 94.0352 97.5476 94.0352 111.475C94.0352 125.403 105.326 136.694 119.254 136.694Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M157.018 148.016L151.641 153.264L136.279 138.031L141.528 132.782L157.018 148.016Z",
    fill: "#D85D0D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7719 95.2746C87.2505 106.796 87.2505 125.358 98.7719 136.751C110.293 148.144 128.855 148.272 140.249 136.751C151.77 125.23 151.77 106.668 140.249 95.2746C128.727 83.8814 110.165 83.7534 98.7719 95.2746ZM135.512 132.142C126.679 140.975 112.213 140.975 103.38 132.142C94.5474 123.309 94.5474 108.844 103.38 100.011C112.213 91.1782 126.679 91.1782 135.512 100.011C144.473 108.844 144.473 123.181 135.512 132.142Z",
    fill: "url(#paint31_linear_8168_48835)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M165.338 161.586C162.906 164.018 159.065 164.018 156.761 161.586L141.143 146.097C140.119 145.201 140.119 143.536 141.143 142.64L146.264 137.52C147.16 136.624 148.696 136.624 149.72 137.52L165.338 153.009C167.642 155.442 167.642 159.282 165.338 161.586Z",
    fill: "url(#paint32_linear_8168_48835)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M164.481 11.8758C162.838 12.634 162.08 14.5296 162.712 16.1725C163.47 17.8153 165.366 18.5735 167.009 17.9417C168.652 17.1834 169.41 15.2879 168.778 13.645C168.146 11.8758 166.124 11.1175 164.481 11.8758Z",
    fill: "#59CF1E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M161.07 6.44072C160.565 5.30337 159.301 4.79787 158.163 5.30337C157.026 5.80886 156.521 7.07259 157.026 8.20994C157.532 9.3473 158.795 9.85279 159.933 9.3473C161.07 8.96818 161.576 7.57808 161.07 6.44072Z",
    fill: "#59CF1E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2337 151.265C18.2667 150.886 20.5414 148.105 20.1623 145.072C19.7832 142.039 17.003 139.765 13.97 140.144C10.937 140.523 8.66221 143.303 9.04134 146.336C9.29409 149.369 12.0743 151.644 15.2337 151.265Z",
    fill: "#59CF1E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8168_48835",
    x: 0.964844,
    y: 25.1816,
    width: 180.721,
    height: 135.785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8168_48835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8168_48835",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8168_48835",
    x: 100.561,
    y: 103.015,
    width: 89.8301,
    height: 62.1777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8168_48835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8168_48835",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8168_48835",
    x1: 22.7454,
    y1: 41.9824,
    x2: 112.33,
    y2: 41.9824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8168_48835",
    x1: 130.211,
    y1: 120.328,
    x2: 161.223,
    y2: 120.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8168_48835",
    x1: 130.211,
    y1: 126.426,
    x2: 151.018,
    y2: 126.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8168_48835",
    x1: 111.116,
    y1: 71.0669,
    x2: 141.362,
    y2: 71.0669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8168_48835",
    x1: 111.116,
    y1: 77.0161,
    x2: 131.41,
    y2: 77.0161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8168_48835",
    x1: 111.116,
    y1: 97.6565,
    x2: 141.362,
    y2: 97.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8168_48835",
    x1: 111.116,
    y1: 103.604,
    x2: 131.41,
    y2: 103.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8168_48835",
    x1: 45.16,
    y1: 94.3211,
    x2: 39.3669,
    y2: 86.4176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B50C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8168_48835",
    x1: 105.702,
    y1: 95.8647,
    x2: 98.2447,
    y2: 94.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B50C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8168_48835",
    x1: 138.703,
    y1: 116.251,
    x2: 140.567,
    y2: 92.1368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8168_48835",
    x1: 112.95,
    y1: 109.615,
    x2: 110.585,
    y2: 100.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8168_48835",
    x1: 104.724,
    y1: 83.97,
    x2: 105.841,
    y2: 115.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2781B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8168_48835",
    x1: 107.536,
    y1: 106.549,
    x2: 105.945,
    y2: 100.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8168_48835",
    x1: 48.3839,
    y1: 102.773,
    x2: 46.4467,
    y2: 95.6798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8168_48835",
    x1: 42.1665,
    y1: 80.1855,
    x2: 41.8887,
    y2: 108.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2781B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8168_48835",
    x1: 43.8641,
    y1: 100.055,
    x2: 42.6032,
    y2: 95.4283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8168_48835",
    x1: 104.07,
    y1: 69.508,
    x2: 105.566,
    y2: 87.5482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8168_48835",
    x1: 85.923,
    y1: 77.5411,
    x2: 104.086,
    y2: 71.2077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8168_48835",
    x1: 138.496,
    y1: 41.2759,
    x2: 73.3422,
    y2: 111.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8168_48835",
    x1: 121.249,
    y1: 99.5332,
    x2: 122.204,
    y2: 87.1867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8168_48835",
    x1: 117.522,
    y1: 90.3168,
    x2: 125.09,
    y2: 87.6771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8168_48835",
    x1: 130.02,
    y1: 75.4863,
    x2: 73.0289,
    y2: 140.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8168_48835",
    x1: 68.5532,
    y1: 73.6231,
    x2: 67.9923,
    y2: 79.7151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8168_48835",
    x1: 61.9289,
    y1: 68.871,
    x2: 72.1154,
    y2: 84.4734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8EBF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8168_48835",
    x1: 83.5791,
    y1: 76.6878,
    x2: 84.2214,
    y2: 84.4417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_8168_48835",
    x1: 79.7104,
    y1: 67.8997,
    x2: 79.9515,
    y2: 70.7911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8168_48835",
    x1: 112.504,
    y1: 90.203,
    x2: 145.997,
    y2: 108.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8168_48835",
    x1: 66.479,
    y1: 62.6992,
    x2: 62.6257,
    y2: 99.7389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_8168_48835",
    x1: 73.3362,
    y1: 96.4377,
    x2: 71.8919,
    y2: 104.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_8168_48835",
    x1: 34.0257,
    y1: 87.2468,
    x2: 35.0113,
    y2: 99.1294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_8168_48835",
    x1: 121.955,
    y1: 106.38,
    x2: 123.575,
    y2: 85.4305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_8168_48835",
    x1: 90.1341,
    y1: 116.019,
    x2: 148.851,
    y2: 116.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_8168_48835",
    x1: 140.339,
    y1: 150.133,
    x2: 167.093,
    y2: 150.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })))));
};
export default SvgCarRentalsStep1;